/* Securitylab brand layer: behaviour that needs a script. Everything visual lives in
   assets/securitylab-brand.css; the markup these functions touch is rendered by the theme's
   Liquid, so nothing here changes the page structure.
   1. Buying Guides carousel: the two arrow buttons in the section header drive the theme's
      Flickity instance.
   2. Collection intro on phones: clamp to three lines with a Read more toggle.
   3. Pay Options link on the product page: smooth scroll to the payment logos.
   4. Key specs on touch screens: the hover state plays while a cell is touched.
   5. Wishlist count: number only (the Wishlist Hero app writes " (1)"), moved onto the icon.
   6. Product page tabs (1 Oct): the lit tab, tab taps, the reviews link and the phone accordion.
   7. Accessories on the product page (1 Oct): Add buttons, quantity steppers, cart sync, no drawer. */
(function () {
  /* ---- 1. carousel arrows ---- */
  function guideArrows() {
    var wraps = document.querySelectorAll('[data-sl-arrows]');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      if (wrap.classList.contains('is-ready') || !window.Flickity) continue;
      var sec = wrap.closest('[data-section-type="blog"]') || wrap.parentNode.parentNode;
      var grid = sec.querySelector('.flickity-enabled');
      if (!grid) continue;
      var flk = window.Flickity.data(grid);
      if (!flk) continue;
      (function (f) {
        wrap.querySelector('.sl-arrow--prev').addEventListener('click', function () { f.previous(); });
        wrap.querySelector('.sl-arrow--next').addEventListener('click', function () { f.next(); });
      })(flk);
      wrap.classList.add('is-ready');
    }
  }

  /* ---- 2. collection intro on phones ---- */
  function collectionIntro() {
    if (window.innerWidth > 768) return;
    var lines = 3;
    var d = document.querySelector('.collection-hero__header .collection__description');
    if (!d || d.querySelector('.sl-readmore')) return;
    var inner = d.querySelector('.metafield-rich_text_field') || d.querySelector('.collection__intro') || d;
    var lh = parseFloat(getComputedStyle(inner).lineHeight) || 23;
    if (inner.scrollHeight <= lh * (lines + 0.4)) return;
    d.classList.add('sl-clamped');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'sl-readmore'; btn.textContent = 'Read more';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = d.classList.toggle('sl-clamped') === false;
      btn.textContent = open ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    d.appendChild(btn);
  }

  /* ---- 3. smooth scroll for in-page links marked data-sl-scroll (the anchor still works without this) ---- */
  function scrollLinks() {
    var links = document.querySelectorAll('a[data-sl-scroll]');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function (e) {
        var id = (this.getAttribute('href') || '').replace(/^#/, '');
        var target = id && document.getElementById(id);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    }
  }

  /* ---- 4. key specs on touch screens: white lift, glow and deep red icon while a cell is
     touched, lingering 450ms after the finger lifts so a tap shows it ---- */
  function specTouch() {
    if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
    var cards = document.querySelectorAll('.specs-wrapper .spec-card');
    for (var i = 0; i < cards.length; i++) (function (card) {
      var timer;
      card.addEventListener('touchstart', function () { clearTimeout(timer); card.classList.add('is-touch'); }, { passive: true });
      var off = function () { clearTimeout(timer); timer = setTimeout(function () { card.classList.remove('is-touch'); }, 450); };
      card.addEventListener('touchend', off, { passive: true });
      card.addEventListener('touchcancel', off, { passive: true });
    })(cards[i]);
  }

  /* ---- 5. wishlist count ---- */
  function clean(el) {
    var t = el.textContent || '';
    var n = t.replace(/[^0-9]/g, '');
    if (t !== n) el.textContent = n;
    /* the app appends its count span to the link; move it onto the icon wrapper so the badge
       sits at the icon's top-right corner exactly like the cart badge (1 Oct) */
    var link = el.closest && el.closest('.wishlist-hero-header-icon');
    var wrap = link && link.querySelector('.sl-wl-link');
    if (wrap && el.parentNode !== wrap) wrap.appendChild(el);
  }
  function scan(root) {
    var list = (root || document).querySelectorAll ? (root || document).querySelectorAll('.wishlist-hero-items-count') : [];
    for (var i = 0; i < list.length; i++) clean(list[i]);
  }

  /* ---- 6. product page tabs (sections/product-scroll-tabs.liquid) ----
     Replaces the version that lived in custom.js, which lit whichever panel crossed a band in
     the middle of the screen (so on phones the folded headings under an open section took the
     light one after another), scrolled a tab tap to a panel that stayed folded, and folded a
     panel when anything inside it was tapped, text included.
     Now, on every width: the lit tab is the last panel whose top has passed the bottom edge of
     the sticky bar; a tab tap lands the panel just under the bar and keeps its tab lit until
     the panel is there (or the reader scrolls). On phones the panels are an accordion: the
     heading row alone folds and unfolds its panel, a tab tap unfolds its panel before scrolling,
     and the bar slides sideways so the lit tab stays in view. */
  function productTabs() {
    var sec = document.querySelector('[data-product-scroll-tabs]');
    if (!sec) return;
    var bar = sec.querySelector('.vimel-product-tabs__nav-wrap');
    var nav = sec.querySelector('.vimel-product-tabs__nav');
    var links = [].slice.call(sec.querySelectorAll('[data-product-tab-link]'));
    var panels = [].slice.call(sec.querySelectorAll('[data-product-tab-panel]'));
    if (!bar || !links.length || !panels.length) return;
    var OPEN = 'active_scroll_tab';
    var held = null, queued = false, lit = null;
    function phone() { return window.matchMedia('(max-width: 768px)').matches; }
    function panelFor(link) { var id = (link.getAttribute('href') || '').replace(/^#/, ''); return id ? document.getElementById(id) : null; }
    function linkFor(panel) { for (var i = 0; i < links.length; i++) if (panelFor(links[i]) === panel) return links[i]; return null; }
    function headingOf(panel) { return panel.querySelector('.vimel-product-tabs__content > h2'); }

    /* the bar: where its bottom edge sits once stuck, the gap a tab tap leaves under it, and how
       far a panel top must be from the page top to land there. A panel counts as "under the
       bar" from 4px below that gap, so a landed panel is the lit one. */
    function gap() { return phone() ? 8 : 16; }
    function barLine() { return bar.getBoundingClientRect().bottom + gap() + 4; }
    function landing(panel) {
      var stuckTop = parseFloat(getComputedStyle(bar).top) || 0;
      return panel.getBoundingClientRect().top + window.pageYOffset - stuckTop - bar.offsetHeight - gap();
    }

    /* keep the lit tab in view when the bar scrolls sideways (phones) */
    function reveal(link) {
      if (!nav || nav.scrollWidth <= nav.clientWidth + 2) return;
      var nr = nav.getBoundingClientRect(), lr = link.getBoundingClientRect();
      var left = lr.left - nr.left + nav.scrollLeft, right = left + lr.width, pad = 14;
      if (left < nav.scrollLeft + pad) nav.scrollTo({ left: Math.max(0, left - pad), behavior: 'smooth' });
      else if (right > nav.scrollLeft + nav.clientWidth - pad) nav.scrollTo({ left: right - nav.clientWidth + pad, behavior: 'smooth' });
    }
    function light(link) {
      if (link === lit) return;
      lit = link;
      for (var i = 0; i < links.length; i++) links[i].classList.toggle('is-active', links[i] === link);
      if (link) reveal(link);
    }
    function current() {
      var line = barLine(), cur = panels[0];
      for (var i = 0; i < panels.length; i++) if (panels[i].getBoundingClientRect().top <= line) cur = panels[i];
      return cur;
    }
    function spy() {
      queued = false;
      var cur = current();
      if (held && cur === held) held = null;
      light(linkFor(held || cur));
    }
    function onScroll() { if (!queued) { queued = true; requestAnimationFrame(spy); } }
    function release() { held = null; }

    /* phone accordion */
    function setOpen(panel, yes) {
      panel.classList.toggle(OPEN, yes);
      var h = headingOf(panel);
      if (h) h.setAttribute('aria-expanded', yes ? 'true' : 'false');
    }
    function syncHeadings() {
      var p = phone();
      for (var i = 0; i < panels.length; i++) {
        var h = headingOf(panels[i]);
        if (!h) continue;
        if (p) {
          h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0');
          h.setAttribute('aria-expanded', panels[i].classList.contains(OPEN) ? 'true' : 'false');
        } else {
          h.removeAttribute('role'); h.removeAttribute('tabindex'); h.removeAttribute('aria-expanded');
        }
      }
    }

    /* a tab tap: unfold on phones, land the heading under the bar, keep the tab lit meanwhile */
    function go(panel) {
      if (!panel) return;
      if (phone() && !panel.classList.contains(OPEN)) setOpen(panel, true);
      held = panel;
      light(linkFor(panel));
      window.scrollTo({ top: Math.max(0, landing(panel)), behavior: 'smooth' });
    }

    sec.addEventListener('click', function (e) {
      var link = e.target.closest('[data-product-tab-link]');
      if (link) { e.preventDefault(); go(panelFor(link)); return; }
      var h = e.target.closest('.vimel-product-tabs__content > h2');
      if (h && phone()) {
        var panel = h.closest('[data-product-tab-panel]');
        if (panel) setOpen(panel, !panel.classList.contains(OPEN));
      }
    });
    sec.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var h = e.target.closest && e.target.closest('.vimel-product-tabs__content > h2');
      if (!h || !phone()) return;
      e.preventDefault();
      var panel = h.closest('[data-product-tab-panel]');
      if (panel) setOpen(panel, !panel.classList.contains(OPEN));
    });
    /* the reviews count under the title links to the reviews panel */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.scroll-to-review');
      if (!a) return;
      var panel = sec.querySelector('.vimel-product-tabs__panel--reviews');
      if (!panel) return;
      e.preventDefault(); e.stopPropagation();
      go(panel);
    }, true);
    /* a hand on the page ends a tab tap's hold */
    window.addEventListener('touchstart', release, { passive: true });
    window.addEventListener('wheel', release, { passive: true });
    window.addEventListener('keydown', release);
    window.addEventListener('scroll', onScroll, { passive: true });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { syncHeadings(); spy(); }, 120); });
    syncHeadings();
    spy();
  }

  /* ---- 7. accessories on the product page (snippets/product-complementary.liquid) ----
     Each row has an Add button that becomes a quantity stepper once the item is in the cart.
     Everything goes through the cart API directly (add.js / change.js), the header badge and
     the drawer contents are refreshed, and the cart drawer is NOT opened: the row itself shows
     the state. Quantities are read from the cart on load and whenever the theme reports a cart
     change, so the rows agree with the drawer. ---- */
  function accessories() {
    var box = document.querySelector('[data-sl-acc]');
    if (!box) return;
    var items = [].slice.call(box.querySelectorAll('[data-sl-acc-item]'));
    var countEl = box.querySelector('[data-sl-acc-count]');
    var totalEl = box.querySelector('[data-sl-acc-total]');
    var viewEl = box.querySelector('[data-sl-acc-view]');
    var cart = null, busy = 0;

    function money(cents) {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function headers() { return { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }; }
    function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
    function addLine(id) {
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: headers(), body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return getCart(); });
    }
    function changeLine(id, qty) {
      return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: headers(), body: JSON.stringify({ id: String(id), quantity: qty }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); });
    }
    function qtyOf(id) {
      if (!cart || !cart.items) return 0;
      var n = 0;
      for (var i = 0; i < cart.items.length; i++) if (String(cart.items[i].variant_id) === String(id)) n += cart.items[i].quantity;
      return n;
    }
    function render() {
      var count = 0, total = 0;
      for (var i = 0; i < items.length; i++) {
        var it = items[i], id = it.getAttribute('data-variant-id'), n = qtyOf(id);
        var add = it.querySelector('[data-sl-acc-add]'), q = it.querySelector('[data-sl-acc-qty]'), nEl = it.querySelector('[data-sl-acc-n]');
        it.classList.toggle('is-in', n > 0);
        if (add) add.hidden = n > 0;
        if (q) q.hidden = !(n > 0);
        if (nEl) nEl.textContent = n;
        if (n > 0) { count += n; total += n * (parseInt(it.getAttribute('data-price'), 10) || 0); }
      }
      if (countEl) countEl.textContent = count === 0 ? 'Add what you need. It goes straight to your cart.' : (count === 1 ? '1 accessory in your cart' : count + ' accessories in your cart');
      if (totalEl) { totalEl.textContent = money(total); totalEl.hidden = count === 0; }
      if (viewEl) viewEl.hidden = count === 0;
      box.classList.toggle('has-items', count > 0);
    }
    function badge() {
      if (!cart) return;
      var els = document.querySelectorAll('.cart-link__bubble');
      for (var i = 0; i < els.length; i++) {
        els[i].textContent = cart.item_count;
        els[i].classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
      }
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
    function fail(it) {
      it.classList.add('is-error');
      setTimeout(function () { it.classList.remove('is-error'); }, 1200);
    }
    function run(it, work) {
      if (it.classList.contains('is-busy')) return;
      it.classList.add('is-busy'); busy++;
      work().then(function (c) { cart = c; render(); badge(); })
        .catch(function () { fail(it); return getCart().then(function (c) { cart = c; render(); }).catch(function () {}); })
        .then(function () { it.classList.remove('is-busy'); busy--; });
    }

    box.addEventListener('click', function (e) {
      var it = e.target.closest('[data-sl-acc-item]');
      if (!it || !box.contains(it)) return;
      var id = it.getAttribute('data-variant-id');
      if (e.target.closest('[data-sl-acc-add]')) {
        if (!it.hasAttribute('data-sold-out')) run(it, function () { return addLine(id); });
        return;
      }
      if (e.target.closest('[data-sl-acc-inc]')) { run(it, function () { return changeLine(id, qtyOf(id) + 1); }); return; }
      if (e.target.closest('[data-sl-acc-dec]')) { run(it, function () { return changeLine(id, Math.max(0, qtyOf(id) - 1)); }); return; }
    });
    /* the theme's drawer reports its own changes */
    document.addEventListener('cart:updated', function (e) {
      if (busy) return;
      if (e.detail && e.detail.cart) { cart = e.detail.cart; render(); }
      else getCart().then(function (c) { cart = c; render(); }).catch(function () {});
    });
    document.addEventListener('cart:refresh', function () {
      if (busy) return;
      getCart().then(function (c) { cart = c; render(); }).catch(function () {});
    });
    getCart().then(function (c) { cart = c; render(); }).catch(function () { render(); });
  }

  /* ---- 8. what's in the box (snippets/sl-box.liquid, build 6f) ----
     Each row of the parts list lights its part in the box picture: the part lifts, the others fade
     and its trail turns red. Mouse: while hovering a row or a part. Touch: a tap lights a row until
     the same row, another row or anything else is tapped. The first time the picture comes into
     view the parts rise out of the box (skipped with reduced motion or without IntersectionObserver). */
  function boxParts() {
    var boxes = document.querySelectorAll('[data-sl-box]');
    for (var b = 0; b < boxes.length; b++) (function (box) {
      var cur = null;
      var hover = window.matchMedia('(hover: hover)').matches;
      var marked = box.querySelectorAll('[data-i]');
      function set(i) {
        cur = i;
        box.classList.toggle('has-on', i !== null);
        for (var k = 0; k < marked.length; k++) marked[k].classList.toggle('is-on', marked[k].getAttribute('data-i') === i);
      }
      var hits = box.querySelectorAll('.sl-parts__row[data-i], .sl-unbox__chip[data-i]');
      for (var r = 0; r < hits.length; r++) (function (el) {
        el.addEventListener('mouseenter', function () { if (hover) set(el.getAttribute('data-i')); });
        el.addEventListener('mouseleave', function () { if (hover) set(null); });
        el.addEventListener('click', function () {
          if (hover) return;
          var i = el.getAttribute('data-i');
          set(cur === i ? null : i);
        });
      })(hits[r]);
      document.addEventListener('click', function (e) {
        if (hover || cur === null) return;
        if (e.target.closest && e.target.closest('[data-sl-box] [data-i]')) return;
        set(null);
      });

      var stage = box.querySelector('.sl-unbox__stage');
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!stage || calm || !('IntersectionObserver' in window)) return;
      box.classList.add('sl-anim');
      var io = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (!entries[j].isIntersecting) continue;
          io.disconnect();
          requestAnimationFrame(function () {
            box.classList.add('is-in');
            setTimeout(function () { box.classList.add('is-done'); }, 1700);
          });
          return;
        }
      }, { threshold: 0.35 });
      io.observe(stage);
    })(boxes[b]);
  }

  function start() {
    guideArrows();
    setTimeout(guideArrows, 1500);   /* the carousel initialises after load */
    collectionIntro();
    scrollLinks();
    specTouch();
    productTabs();
    accessories();
    boxParts();
    scan(document);
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        if (el && el.closest) {
          var c = el.closest('.wishlist-hero-items-count');
          if (c) clean(c);
        }
        if (m.addedNodes) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType === 1) {
              if (n.classList && n.classList.contains('wishlist-hero-items-count')) clean(n);
              else scan(n);
            }
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
